import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import GalleryPage from "./pages/GalleryPage";
import BoilerErrorCodesPage from "./pages/BoilerErrorCodesPage";
import ServicesPage from "./pages/ServicesPage";
import FloatingWhatsApp from "./components/ui/FloatingWhatsApp";

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/boiler-error-codes" element={<BoilerErrorCodesPage />} />
      </Routes>
      <FloatingWhatsApp />
    </BrowserRouter>
  );
}

export default App;
